import { Modal, Form, Input, message } from "antd";
import React, { useState } from "react";
import type { Carpool, CarpoolRole } from "../types";
import type { CarpoolStore } from "../store";

interface Props {
  store: CarpoolStore;
  carpool: Carpool;
  open: boolean;
  onClose: () => void;
}

const MODAL_TITLE: Record<CarpoolRole, string> = {
  driver: "Mitfahren",
  rider: "Fahrt anbieten",
  train: "Kontakt aufnehmen",
};

const OK_TEXT: Record<CarpoolRole, string> = {
  driver: "Anfrage senden",
  rider: "Angebot senden",
  train: "Nachricht senden",
};

const SUCCESS_MESSAGE: Record<CarpoolRole, string> = {
  driver: "Anfrage gesendet! Der Fahrer wird per E-Mail benachrichtigt.",
  rider: "Angebot gesendet! Die suchende Person wird per E-Mail benachrichtigt.",
  train: "Nachricht gesendet! Die Person wird per E-Mail benachrichtigt.",
};

const FOOTER_NOTE: Record<CarpoolRole, string> = {
  driver: "Deine Kontaktdaten werden dem Fahrer per E-Mail zugesendet und nicht öffentlich gespeichert.",
  rider: "Deine Kontaktdaten werden der suchenden Person per E-Mail zugesendet und nicht öffentlich gespeichert.",
  train: "Deine Kontaktdaten werden der Person per E-Mail zugesendet und nicht öffentlich gespeichert.",
};

export const JoinRequestModal = ({ store, carpool, open, onClose }: Props) => {
  const [form] = Form.useForm();
  const [submitting, setSubmitting] = useState(false);

  const handleOk = async () => {
    const values = await form.validateFields();
    if (!values.email && !values.phone) {
      message.error("Bitte E-Mail oder Telefonnummer angeben.");
      return;
    }
    setSubmitting(true);
    try {
      const contact = [values.email, values.phone].filter(Boolean).join(", ");
      await store.contactCarpool(carpool.objectId!, values.name, contact);
      message.success(SUCCESS_MESSAGE[carpool.role]);
      form.resetFields();
      onClose();
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Modal
      open={open}
      title={`${MODAL_TITLE[carpool.role]}: ${carpool.origin} → ${carpool.destination}`}
      okText={OK_TEXT[carpool.role]}
      cancelText="Abbrechen"
      confirmLoading={submitting}
      onOk={handleOk}
      onCancel={() => { form.resetFields(); onClose(); }}
    >
      <Form form={form} layout="vertical">
        <Form.Item
          name="name"
          label="Dein Name"
          rules={[{ required: true, message: "Bitte Name eingeben" }]}
        >
          <Input />
        </Form.Item>
        <Form.Item
          name="email"
          label="E-Mail"
          rules={[{ type: "email", message: "Bitte gültige E-Mail eingeben" }]}
        >
          <Input type="email" />
        </Form.Item>
        <Form.Item name="phone" label="Telefonnummer">
          <Input />
        </Form.Item>
      </Form>
      <div style={{ color: "#888", fontSize: 12 }}>
        {FOOTER_NOTE[carpool.role]}
      </div>
    </Modal>
  );
};
